import React, {useRef} from 'react';
import {PlayerTab} from '@/features/players/types';

interface PlayerTabsProps {
  tabs: PlayerTab[];
  active: PlayerTab;
  onChange: (id: PlayerTab) => void;
}

const labels: Record<PlayerTab, string> = {
  overview: 'Overview', reports: 'Reports', documents: 'Documents', analysis: 'Analysis',
};

const PlayerTabs: React.FC<PlayerTabsProps> = ({tabs, active, onChange}) => {
  const refs = useRef<Array<HTMLButtonElement | null>>([]);
  const selectAt = (index: number) => {
    const selected = tabs[(index + tabs.length) % tabs.length];
    refs.current[tabs.indexOf(selected)]?.focus();
    onChange(selected);
  };
  return (
    <nav aria-label="Player detail sections" className="min-w-0 overflow-x-auto">
      <div className="flex min-w-max gap-1" role="tablist" aria-orientation="horizontal">
      {tabs.map((tab, index) => (
        <button
          ref={element => { refs.current[index] = element; }}
          key={tab} id={`player-tab-${tab}`} type="button" role="tab" aria-selected={tab === active}
          aria-controls={`player-panel-${tab}`} tabIndex={tab === active ? 0 : -1}
          onClick={() => onChange(tab)}
          onKeyDown={event => {
            let next: number | undefined;
            if (event.key === 'ArrowRight') next = index + 1;
            if (event.key === 'ArrowLeft') next = index - 1;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            selectAt(next);
          }}
          className={`min-h-11 whitespace-normal break-words rounded-md px-3 py-2 text-sm font-semibold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-club-blue-500 ${tab === active ? 'bg-club-blue-700 text-white' : 'text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800'}`}
        >
          {labels[tab]}
        </button>
      ))}
      </div>
    </nav>
  );
};

export default PlayerTabs;
